<template>
  <div>
    <v-btn
      light
      fab
      fixed
      bottom
      right
      color="primary"
      class="hidden-sm-and-up"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50px;
      "
    >
      <img
        src="@/assets/back-office/icons/chevron_icon_left.svg"
        alt=""
        width="30px"
        @click="$router.back()"
        style="cursor: pointer"
      />
      <h2 class="text-xs-center">
        Invoice Management ({{ $route.params.manager_name }})
      </h2>
      <div></div>
      <v-btn
        :to="`/weserve_admin_login/-/manager-manage/${$route.params.manager_id}/${$route.params.manager_name}/${$route.params.province_id}/invoice/create`"
        color="#ffd600"
        class="elevation-0 btn-style-1 hidden-xs-only"
        absolute
        ><v-icon>add</v-icon> CREATE INVOICE</v-btn
      >
    </div>
    <v-card class="mt-3">
      <v-layout wrap>
        <v-flex class="pa-3">
          <v-text-field
            v-model="searchText"
            prepend-icon="search"
            placeholder="Search invoice number / invoice type / description"
          ></v-text-field
        ></v-flex>
        <v-flex class="pa-3">
          <v-select
            v-model="filterStatus"
            item-text="name"
            item-value="value"
            :items="[
              { name: 'All status', value: 0 },
              { name: 'Pending', value: 1 },
              { name: 'Overdue', value: 3 },
              { name: 'Complete', value: 2 },
            ]"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="filterInvoiceList"
        :rows-per-page-items="[50, 100, 200]"
        :loading="isLoading"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              {{ invoiceList.indexOf(props.item) + 1 }}
            </td>
            <td class="text-xs-center">
              {{ moment(props.item.create_at).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ moment(props.item.bill_due_date).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ props.item.bill_number }}
            </td>
            <td class="text-xs-center">
              {{ props.item.bill_type.bill_type_name }}
            </td>
            <td class="text-xs-center">
              {{ props.item.bill_description }}
            </td>
            <td class="text-xs-center">
              {{ props.item.bill_net_price }}
            </td>
            <td class="text-xs-center">
              <span
                v-if="props.item.bill_status == 2"
                style="
                  padding: 2px 10px;
                  background-color: #4caf50;
                  border-radius: 6px;
                  color: white;
                  font-size: 12px;
                  font-weight: bold;
                "
              >
                COMPLETE
              </span>
              <span
                v-else-if="props.item.bill_status == 3"
                style="
                  padding: 2px 10px;
                  background-color: #f44336;
                  border-radius: 6px;
                  color: white;
                  font-size: 12px;
                  font-weight: bold;
                "
              >
                OVERDUE
              </span>
              <span
                v-else-if="props.item.bill_status == 1"
                style="
                  padding: 2px 10px;
                  background-color: #ffd600;
                  border-radius: 6px;
                  color: white;
                  font-size: 12px;
                  font-weight: bold; ;
                "
              >
                PENDING
              </span>
            </td>
            <td class="text-xs-center" style="white-space: nowrap">
              <v-btn
                icon
                :to="`/weserve_admin_login/-/manager-manage/${$route.params.manager_id}/${$route.params.manager_name}/${$route.params.province_id}/invoice/view/${props.item.bill_id}`"
              >
                <v-icon small>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                icon
                :disabled="props.item.bill_status == 2"
                :to="`/weserve_admin_login/-/manager-manage/${$route.params.manager_id}/${$route.params.manager_name}/${$route.params.province_id}/invoice/edit/${props.item.bill_id}`"
              >
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-btn
                icon
                :disabled="props.item.bill_status == 2"
                @click="toDeleteInvoice(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template></v-data-table
      ></v-card
    >
    <v-dialog v-model="confirmDeleteDialog" max-width="400px" persistent>
      <v-card style="border-radius: 16px" class="px-4 py-3">
        <span style="font-weight: 600; font-size: 20px"
          >Are you sure to delete this invoice?</span
        >
        <hr class="my-3" />
        <div style="display: flex; justify-content: flex-end">
          <v-btn
            flat
            color="error"
            @click="confirmDeleteDialog = false"
            :disabled="isDeleteing"
            ><span style="font-weight: 600">cancel</span></v-btn
          >
          <v-btn
            color="#FFD600"
            class="elevation-0"
            style="border-radius: 10px"
            @click="deleteInvoice()"
            :loading="isDeleteing"
            ><span style="font-weight: 600">confirm</span></v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
        },
        {
          text: "Create date",
          align: "center",
          sortable: true,
          value: "create_at",
        },
        {
          text: "Due date",
          align: "center",
          sortable: true,
          value: "bill_due_date",
        },
        {
          text: "Invoice number",
          align: "center",
          sortable: false,
        },
        {
          text: "Invoice type",
          align: "center",
          sortable: false,
        },
        {
          text: "Description",
          align: "center",
          sortable: false,
        },
        {
          text: "Net Price",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
      ],
      isLoading: false,
      filterStatus: 0,
      searchText: "",
      confirmDeleteDialog: false,
      selectedItem: null,
      isDeleteing: false,
    };
  },
  computed: {
    ...mapState({
      invoiceList: (state) => state.invoice.invoiceManagerList,
    }),
    filterInvoiceList() {
      if (this.filterStatus == 0) {
        return this.invoiceList.filter(
          (val) =>
            val.bill_number
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
            val.bill_type.bill_type_name
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
            val.bill_description
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
        );
      } else {
        return this.invoiceList.filter((val) => {
          return (
            val.bill_status == this.filterStatus &&
            (val.bill_number
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
              val.bill_type.bill_type_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase()) ||
              val.bill_description
                .toLowerCase()
                .includes(this.searchText.toLowerCase()))
          );
        });
      }
    },
  },
  methods: {
    ...mapActions({
      getInvoiceList: "invoice/fetchInvoiceManagerList",
      deleteInvoiceManager: "invoice/deleteInvoiceManager",
    }),
    ...mapMutations({
      setInvoiceManagerList: "invoice/setInvoiceManagerList", // map `this.add()` to `this.$store.commit('increment')`
    }),
    toDeleteInvoice(item) {
      this.confirmDeleteDialog = true;
      this.selectedItem = item;
    },
    async deleteInvoice() {
      this.isDeleteing = true;
      let result = await this.deleteInvoiceManager({
        invoice_id: this.selectedItem.bill_id,
      });
      this.isDeleteing = false;
      if (result == true) {
        this.confirmDeleteDialog = false;
      }
    },
  },
  async created() {
    this.isLoading = true;
    this.setInvoiceManagerList([]);
    await this.getInvoiceList({ manager_id: this.$route.params.manager_id });
    this.isLoading = false;
  },
};
</script>

<style scoped>
.btn-style-1 {
  /* Layout Properties */
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  width: 150px;
  height: 40px;
  /* UI Properties */
  border-radius: 10px;
  /* Font Properties */
  font-weight: bold;
}
</style>
